import { useEffect } from 'react';
import { injectHeadScript } from '../util/inject-head-script';

interface HubspotProps {
    hubspotTrackingId: string;
}

export const HubspotHead: React.FC<HubspotProps> = ({ hubspotTrackingId }) => {
    // The loader is injected after hydration (see `injectHeadScript`); as an SSR
    // <script> it would run during parse and break document hydration.
    useEffect(() => {
        injectHeadScript(
            `https://js.hs-scripts.com/${hubspotTrackingId}.js`,
            'hs-script-loader',
        );
    }, [hubspotTrackingId]);

    return null;
};
